import angular from 'angular';

export default class Attribut {
	/**
	 * @param {any} attribut
	 */
	constructor(attribut) {
		this.kid = attribut?.kid || undefined;

		/** @type {string | undefined} */
		this.name = attribut?.name || undefined;

		/** @type {string | undefined} */
		this.ref_type = attribut?.ref_type || undefined;

		if (this.ref_type === 'KEPLER_TYPE;TEXT') {
			this.value = attribut.data1 ?? attribut.value;
		}
		else if (this.ref_type === 'KEPLER_TYPE;JSON') {
			try {
				this.value = JSON.parse(attribut.data1);
			}
			catch {
				this.value = attribut.value;
			}
		}
		else {
			this.value = attribut.value;
		}
	}

	export() {
		/** @type {any} */
		const attribute = {
			name:     this.name,
			ref_type: this.ref_type,
		};

		if (this.ref_type === 'KEPLER_TYPE;TEXT') {
			attribute.data1 = this.value ?? '';
		}
		else if (this.ref_type === 'KEPLER_TYPE;JSON') {
			attribute.data1 = angular.toJson(this.value);
		}
		else {
			attribute.value = this.value;
		}
		return attribute;
	}
}
